export const formatDate = (date) => {
  return (
    date.getFullYear() +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(date.getDate()).padStart(2, "0") +
    "T" +
    String(date.getHours()).padStart(2, "0") +
    ":" +
    String(date.getMinutes()).padStart(2, "0") +
    ":" +
    String(date.getSeconds()).padStart(2, "0") +
    "." +
    String(date.getMilliseconds()).padStart(3, "0")
  );
};

export const formatDateUTC = (date) =>
  date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
    timeZone: "UTC",
  });

export const formatTimeUTC = (date) => {
  let hours = date.getUTCHours();
  let minutes = date.getUTCMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format
  return `${hours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
};

export const base64ToBlob = (base64, mimeType) => {
  const byteCharacters = atob(base64.split(",")[1]); // Decode Base64
  const byteArrays = [];

  for (let i = 0; i < byteCharacters.length; i++) {
    byteArrays.push(byteCharacters.charCodeAt(i));
  }

  return new Blob([new Uint8Array(byteArrays)], { type: mimeType });
};

export const generateEmailBody = (
  lastName,
  formattedDateUTC,
  formattedStartTimeUTC,
  formattedEndTimeUTC,
  blobToImgApi,
  getUserEmployee
) => `
    <html>
        <body style="font-family: Arial, sans-serif; color: #000;">
            <p>Good day, ${lastName}!</p>
            <p>Greetings from <strong>LGS Staff Management Services Incorporated</strong>!</p>
            <p>My name is ${
              getUserEmployee?.sex === "Male" ? "Mr." : "Ms."
            } <strong>${
  getUserEmployee.firstName
}</strong>, HR/Recruitment Officer of LGS Staff Management Services Incorporated. Thank you for showing interest in applying with our company. After viewing your application, I am pleased to invite you for an initial interview to further discuss your application. Please refer to the following details:</p>
            <p><strong>When:</strong> ${formattedDateUTC}</p>
            <p><strong>Time:</strong> Between ${formattedStartTimeUTC} - ${formattedEndTimeUTC}</p>
            <p><strong>Where:</strong> G/F LGS Centre, <a href="https://maps.google.com/?q=1639+Dian+St,+Makati" target="_blank">1639 Dian </a> corner. Rockefeller St. Brgy. San Isidro, Makati City</p>
            <p><strong>Attire:</strong> Formal/Corporate</p>
            <p>Kindly bring your most updated resume, valid ID, and black ballpen. Please reply with your full name in this email as confirmation of your attendance.</p>
            <p>Here is your interview QR Code:</p>
            <img src="${
              blobToImgApi?.url
            }" alt="QR Code" width="200" height="200" />
            <p>Thank you very much and see you!</p>
            <p>Sincerely yours,</p>
            <p><strong>${getUserEmployee?.firstName} ${
  getUserEmployee?.middleName
}. ${getUserEmployee?.lastName}</strong><br>
            Recruitment Officer<br>
            <strong>LGS Staff Management Services Inc.</strong><br>
            <a href="https://maps.google.com/?q=1639+Dian+St,+Makati" target="_blank">1639 Dian St.</a>, Brgy. San Isidro, Makati City, 1234 Philippines</p>
        </body>
    </html>
  `;
